type FIELDS_ERROR_TYPE = { [key: string]: string[] | undefined }

export const hasErrors = (fieldsError: FIELDS_ERROR_TYPE) =>
    Object.keys(fieldsError).some(field => fieldsError[field])

/**
 * @deprecated
 * This solution with "getFieldsValue" method doesn't work in v4 because it doesn't return live values of form inputs
 * when you are doing migration antd v3 -> v4 please use next function "areAllRequiredFieldsFilledAntdV4"
 * where you need to provide as first argument object of input name-values
 * TODO - remove when all current usage places are refactored to antd v4
 * @param form
 * @param requiredFields
 */
export const areAllRequiredFieldsFilled = <
    T extends { getFieldsValue: (fields: string[]) => {} },
>(
    form: T,
    requiredFields: string[],
) => Object.values(form.getFieldsValue(requiredFields)).every(value => value)

/**
 * New form helper to determine if all required fields were filled
 * It's better to use with "onValuesChange" form prop
 * @example
 * onValuesChange={(changedValues, allValues) => {
 *   setButtonDisable(
 *     !areAllRequiredFieldsFilled(
 *       allValues,
 *       REQUIRED_FIELDS,
 *     ),
 *   )
 * }}
 * @param values
 * @param requiredFields
 */
export const areAllRequiredFieldsFilledAntdV4 = (
    values: Record<string, any>,
    requiredFields: string[],
) => requiredFields.every(field => values[field])
